import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart, registerables } from 'chart.js';
import 'chartjs-adapter-luxon';
import { fade } from '@ui/styles';
import { theme, useTheme } from '@ui/theme';
import { getStepUnit, shortFormatter, longFormatter } from './utils';
import { useReport } from './UsageReportContext';

Chart.register(...(registerables || []));

export const LicenseUsageChart: React.FC = () => {
  const { chart, timeSpan } = useReport();
  const { palette } = useTheme();
  const stepConfiguration = getStepUnit(timeSpan);
  const formatter = stepConfiguration.unit === 'day' ? shortFormatter : longFormatter;
  const maximumUsage = chart?.reduce((m, d) => Math.max(m, d.used), 0) || 50;

  return (
    <Line
      data={{
        datasets: [
          {
            label: 'Licenses in use',
            data: chart,
            fill: true,
            borderColor: palette.primary.dark,
            backgroundColor: fade(palette.primary.light, 0.5),
            borderWidth: 1,
            pointRadius: 0,
          },
        ],
      }}
      options={{
        maintainAspectRatio: false,
        responsive: true,
        plugins: { legend: { display: false } },
        elements: { line: { tension: 0 } },
        parsing: {
          xAxisKey: 'time',
          yAxisKey: 'used',
        },
        animation: { duration: 0 },
        layout: { padding: { right: theme.spacing(2) } },
        scales: {
          xAxes: {
            type: 'time',
            display: !!chart,
            time: stepConfiguration,
            min: chart?.[0]?.time || 0,
            max: chart?.[chart.length - 1]?.time || 0,
            ticks: {
              color: palette.common.black,
              maxRotation: 60,
              callback: (_, i, t) => formatter.format(t[i].value),
            },
          },
          yAxes: {
            type: 'linear',
            suggestedMin: 0,
            suggestedMax: maximumUsage,
            ticks: {
              stepSize: maximumUsage > 10 ? 5 : 1,
            },
          },
        },
      }}
    />
  );
};
